<template>
    <page>
        <module title="限时折扣活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">

                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} 至 {{activityInfo.end_date}}</c-detail-item>

                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>

                    <c-detail-item label="商品参加方式">{{rangeTypeMap[activityInfo.commodity_range]}}</c-detail-item>

                    <c-detail-item label="是否支持定制" v-if="systemConfig.product_custom == 'ON'">{{isCustomMap[activityInfo.is_custom]}}</c-detail-item>

                    <c-detail-item label="活动说明">{{activityInfo.activity_remark}}</c-detail-item>

                    <c-detail-item label="活动商品" v-show="activityInfo.commodity_range == 1" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="200"
                            >
                                <template v-slot="{data}">
                                    <div class="flex-center">
                                        <c-image :src="data.product_img_url" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                            {{data.product_name}}
                                        </p>
                                    </div>
                                </template>
                            </c-table-column>

                          <c-table-column
                              label="原价"
                              name="sale_price"
                              width="80"
                          >
                            <template v-slot="{data}">
                              ￥{{data.product_price_min}}
                              <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="活动折扣"
                              width="140"
                              name="activity_discount"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                                    label="促销价"
                                    name="promotion_price"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.activity_discount">
                                     ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                                </template>

                            </c-table-column>

                        </c-table>
                    </c-detail-item>

                    <c-detail-item label="活动品牌" v-show="activityInfo.commodity_range == 2" full>
                        <c-table v-model="brandList" height="auto" border>

                            <c-table-column
                                    label="品牌名称"
                                    name="brand_name"
                                    width="200"
                            ></c-table-column>

                            <c-table-column
                                    label="折扣"
                                    width="140"
                                    name="activity_discount"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                                </template>
                            </c-table-column>

                        </c-table>
                    </c-detail-item>

                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'limit_time_discount_detail',

        props: {
            id: String
        },

        data() {
            return {
                activityInfo: '',
                productList: [],
                brandList: [],
                showTypeMap: {'1':'列表模式','2':'大图模式'},
                rangeTypeMap: {'1':'指定商品','2':'指定品牌'},
                isCustomMap: {'0':'不支持','1':'支持'}
            }
        },

        computed: {
            ...mapState(['dict']),
	        ...mapState(['systemConfig'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySale/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                        this.brandList = data.brand_list;
                    }
                });
            }
        }
    }
</script>